<template>
    <div class="col-lg-4" v-if="model" data-aos="fade-in">
        <div class="partner-card-item">
            <NuxtLink :to="link">
                <SmartLinkItemComponent :id="model?.system?.id" :component="!model?.system?.workflow">                         
                    <div class="logo">
                        <SmartLinkStandaloneElement :codename="type.elements.logo.codename">
                            <img v-if="firstOrDefault(model.elements.logo.value)" :src="model.elements.logo.value[0]!.url" class="img-fluid" />
                        </SmartLinkStandaloneElement>
                    </div>     
                    <div class="title">
                        <SmartLinkStandaloneElement :codename="type.elements.partner_title.codename">
                            <h3 v-if="model.elements.partner_title.value">{{ model.elements.partner_title.value }}</h3>
                        </SmartLinkStandaloneElement>
                    </div>
                    <div class="description">
                        <SmartLinkStandaloneElement :codename="type.elements.short_description.codename">
                            <p v-if="model.elements.short_description.value">{{ model.elements.short_description.value }}</p>
                        </SmartLinkStandaloneElement>
                    </div>          
                </SmartLinkItemComponent>
            </NuxtLink>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { NuxtLink } from '#components';
import { contentTypes, type PartnerItemModel } from '~~/app/models';
const type = contentTypes.partner_item;
const pageStore = usePageStore();
const siteStore = useSiteStore();
const props = defineProps<{ model: PartnerItemModel, link?:string }>();

</script>